import React, { createContext, useContext, useEffect, useState } from 'react';

export const StateContext = createContext([{}, () => null]);

export const StateProvider  = ({ children }) => {
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [isOpened, setIsOpened] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  useEffect(() => {
    if (!isOpened && selectedEvents.length > 0) {
      setTimeout(() => {
        setSelectedEvents([]);
      }, 400);
    }
  }, [isOpened, selectedEvents.length]);

  return (
    <StateContext.Provider
      value={{
        state: {
          selectedEvents,
          selectedDate,
          isOpened,
          showShareModal
        },
        action: {
          setSelectedEvents,
          setSelectedDate,
          setIsOpened,
          setShowShareModal
        }
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export const useStateValues = () => useContext(StateContext);